"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdapterError = void 0;
const domain_error_js_1 = require("./domain-error.js");
/**
 * Thrown by DataAdapter implementations when a database operation fails
 * in a way that the caller should treat as an infrastructure error
 * (as opposed to a domain constraint violation).
 */
class AdapterError extends domain_error_js_1.DomainError {
    constructor(message = 'Adapter error', cause) {
        super(message, 'ADAPTER_ERROR', cause);
    }
}
exports.AdapterError = AdapterError;
//# sourceMappingURL=adapter-error.js.map